// Wrapper for Supabase data manager - maintains backwards compatibility
// This file now proxies to Supabase while keeping the same API
import * as supabaseManager from './supabaseDataManager';

export function getCurrentUser() {
  return supabaseManager.getCurrentUser();
}

// Workout Plans
export async function getUserWorkoutPlans() {
  return await supabaseManager.getUserWorkoutPlans();
}

export async function saveUserWorkoutPlans(plans) {
  return await supabaseManager.saveUserWorkoutPlans(plans);
}

// Workout History
export async function getUserWorkoutHistory() {
  return await supabaseManager.getUserWorkoutHistory();
}

export async function saveUserWorkoutHistory(history) {
  return await supabaseManager.saveUserWorkoutHistory(history);
}

// Add a single workout to history
export async function saveWorkoutHistory(workoutData) {
  const existingHistory = await getUserWorkoutHistory() || [];
  existingHistory.push(workoutData);
  return await saveUserWorkoutHistory(existingHistory);
}

// Detailed Workout History
export async function getUserDetailedWorkoutHistory() {
  return await supabaseManager.getUserDetailedWorkoutHistory();
}

export async function saveUserDetailedWorkoutHistory(history) {
  return await supabaseManager.saveUserDetailedWorkoutHistory(history);
}

// Add a single detailed workout to history
export async function saveDetailedWorkoutHistory(detailedWorkoutData) {
  const existingHistory = await getUserDetailedWorkoutHistory() || [];
  existingHistory.push(detailedWorkoutData);
  return await saveUserDetailedWorkoutHistory(existingHistory);
}

// Measurements
export async function getUserMeasurements() {
  return await supabaseManager.getUserMeasurements();
}

export async function saveUserMeasurements(measurements) {
  return await supabaseManager.saveUserMeasurements(measurements);
}

// Measurement History
export async function getUserMeasurementHistory() {
  return await supabaseManager.getUserMeasurementHistory();
}

export async function saveUserMeasurementHistory(history) {
  return await supabaseManager.saveUserMeasurementHistory(history);
}

// Last Plan Update
export async function getUserLastPlanUpdate() {
  return await supabaseManager.getUserLastPlanUpdate();
}

export async function saveUserLastPlanUpdate(date) {
  return await supabaseManager.saveUserLastPlanUpdate(date);
}

// Last Plan Summary
export async function getUserLastPlanSummary() {
  return await supabaseManager.getUserLastPlanSummary();
}

export async function saveUserLastPlanSummary(summary) {
  return await supabaseManager.saveUserLastPlanSummary(summary);
}

// Weekly Strategy Overview
export async function getUserWeeklyStrategy() {
  return await supabaseManager.getUserWeeklyStrategy();
}

export async function saveUserWeeklyStrategy(strategy) {
  return await supabaseManager.saveUserWeeklyStrategy(strategy);
}

// User Profile
export async function getUserProfile() {
  return await supabaseManager.getUserProfile();
}

export async function updateUserProfile(updates) {
  return await supabaseManager.updateUserProfile(updates);
}

// Switch User
export function switchUser(username) {
  supabaseManager.switchUser(username);
}

// User Settings
export async function saveUserSettings(settings) {
  return await supabaseManager.saveUserSettings(settings);
}

// Logout
export function logoutUser() {
  supabaseManager.logoutUser();
}
